import Avatar from 'react-avatar';
import ReactEmoji from 'react-emoji'

const Message = ({ message: { user, text }, name }) => {
  let currentUser = false;
  const trimmedName = name.trim().toLowerCase();
  if (user === trimmedName) {
    currentUser = true;
  }

   function handleClass(){
        let className = 'flex '
        currentUser ? className += 'justify-end mr-2 ' : className +='justify-start ml-2 '
        return className
    }
  return (
    <div className="my-2">
        <div className={handleClass()}>
          <div className="flex bg-blue-100 px-4 py-3 rounded-lg items-center">
            <Avatar name={user} size="30" round="20px" />
            <div className="flex flex-col ml-3">

            <span className="font-semibold capitalize">{user}</span>
            <span>{ReactEmoji.emojify(text)}</span>
            </div>
          </div>
        </div>
    </div>
  );
};

export default Message;
